import { render, staticRenderFns } from "./MergeDataTable.vue?vue&type=template&id=9763d40a&scoped=true"
import script from "./MergeDataTable.vue?vue&type=script&lang=js"
export * from "./MergeDataTable.vue?vue&type=script&lang=js"
import style0 from "./MergeDataTable.vue?vue&type=style&index=0&id=9763d40a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9763d40a",
  null
  
)

export default component.exports